
<div [formGroup]="form">
  <img [formControlName]="item.name" 
  [ngClass]="item.width === undefined && item.height === undefined?'imgAutoSize':''"
  [style]="item.width!== undefined ? 'width:'+item.width+';':'' +' '+ item.height!== undefined ? 'height:'+item.height+';':''"
  [src]="item.value">
</div>